// to view
export const setSelectedUsers = selectedUsers => {
  return {
    type: "SET_SELECTED_USERS",
    selectedUsers
  };
};
// end to view

//Filters
export const selectSearchWord = searchWord => {
  return {
    type: "SELECT_SEARCH_WORD",
    searchWord
  };
};

export const selectRole = role => {
  return {
    type: "SELECT_ROLE",
    role
  };
};
// end Filters

export const setRole = role => {
  return {
    type: "SET_ROLE",
    role
  };
};

export const setAllowLanguage = (value, language) => {
  return {
    type: "SET_ALLOW_LANGUAGE",
    value,
    language
  };
};

export const openSidebar = () => {
  return {
    type: "SETTINGS_OPEN_SIDEBAR"
  };
};

export const closeSidebar = () => {
  return {
    type: "SETTINGS_CLOSE_SIDEBAR"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/setting.js